export const DEFAULT_DELIVERY_FREIGHT_BRL = 12;

export function getDefaultDeliveryFreightAmount(): number {
  return DEFAULT_DELIVERY_FREIGHT_BRL;
}
